
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function SupportCallSection() {
  const navigate = useNavigate();

  const handleCSRPartnership = () => {
    navigate('/donate');
  };

  const handleDonate = () => {
    navigate('/donate');
  };

  return (
    <section className="py-20 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto">
          {/* Quote Block */}
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-lg mb-12">
            <div className="mb-6">
              <i className="ri-double-quotes-l text-4xl text-[#12B6B6] mb-4"></i>
            </div>
            <blockquote className="text-2xl md:text-3xl font-bold text-[#111111] leading-relaxed mb-6">
              "Your early support will help us build India's first oxygen-first healthcare movement."
            </blockquote>
            <div className="text-gray-600">
              — Diatomic Life Foundation Team
            </div>
          </div>

          {/* Supporting Text */}
          <div className="mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6">
              Why Support Us Now
            </h2>
            <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
              Early supporters don't just fund programs—they help shape the future of healthcare in India. 
              Your contribution today lays the foundation for a healthier tomorrow.
            </p>
          </div>

          {/* Benefits of Early Support */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white rounded-2xl p-6">
              <div className="w-16 h-16 bg-[#12B6B6]/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-rocket-line text-2xl text-[#12B6B6]"></i>
              </div>
              <h3 className="text-lg font-semibold text-[#111111] mb-2">Pioneer Impact</h3>
              <p className="text-sm text-gray-600">Be part of launching India's first comprehensive oxygen deficiency program</p>
            </div>
            
            <div className="bg-white rounded-2xl p-6">
              <div className="w-16 h-16 bg-[#12B6B6]/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-eye-line text-2xl text-[#12B6B6]"></i>
              </div>
              <h3 className="text-lg font-semibold text-[#111111] mb-2">Full Transparency</h3>
              <p className="text-sm text-gray-600">Watch your contribution create measurable change from day one</p>
            </div>
            
            <div className="bg-white rounded-2xl p-6">
              <div className="w-16 h-16 bg-[#12B6B6]/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-community-line text-2xl text-[#12B6B6]"></i>
              </div>
              <h3 className="text-lg font-semibold text-[#111111] mb-2">Community Building</h3>
              <p className="text-sm text-gray-600">Join a movement that puts preventive healthcare first</p>
            </div>
          </div>

          {/* Call to Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="primary" 
              size="lg" 
              className="px-12 py-4 text-lg font-semibold whitespace-nowrap"
              onClick={handleCSRPartnership}
            >
              Partner with Us (CSR)
            </Button>
            <Button 
              variant="secondary" 
              size="lg" 
              className="px-12 py-4 text-lg font-semibold whitespace-nowrap"
              onClick={handleDonate}
            >
              Sponsor a Family (Donate)
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8 text-sm text-gray-600">
              <div className="flex items-center space-x-2">
                <i className="ri-shield-check-line text-[#12B6B6]"></i>
                <span>80G Tax Benefits</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-file-text-line text-[#12B6B6]"></i>
                <span>Instant Receipts</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-bank-card-line text-[#12B6B6]"></i>
                <span>Secure Payments</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-eye-line text-[#12B6B6]"></i>
                <span>Complete Transparency</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
